"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationFields = exports.ReservationStatus = exports.ITINERARY_ONLY_PRICE = void 0;
var __1 = require("..");
exports.ITINERARY_ONLY_PRICE = (0, __1.Money)(50);
var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["Pending"] = "Pending";
    ReservationStatus["Payed"] = "Payed";
    ReservationStatus["Confirmed"] = "Confirmed";
    ReservationStatus["Canceled"] = "Canceled";
})(ReservationStatus = exports.ReservationStatus || (exports.ReservationStatus = {}));
exports.ReservationFields = [
    'reservationId',
    'reservationType',
    'status',
    'userId',
    'firstName',
    'lastName',
    'email',
    'phoneNumber',
    // 'billingZipCode',
    // 'billingCountry',
    'tripId',
    'tripVersionId',
    'inventoryId',
    'tripDate',
    'people',
    'totalPrice',
    'currency',
    'couponCode',
    'couponTitle',
    'discount',
    'depositPaid',
    'depositAmount',
    // 'stripeResponse',
    'jwtToken',
    'tokenExpiresAt',
    'installmentPayments',
];
//# sourceMappingURL=Reservation.js.map